export default __webpack_public_path__ + "static/media/Metallic Ringing.a2de1e5b.png";